export default __webpack_public_path__ + "static/imagePC-c9a713bbadcf81b14a34647e99b03ef0.svg";